import { ProviderInstanceResourceModel } from '../provider-instance-resource-model';
import { ReportProfileRulesComputedDelegate } from '../profile/report-profile-rules-computed-delegate';

export class ReportProfileResourceBase<A> {
  providerInstanceResource: ProviderInstanceResourceModel;
  lastAccess: Date|null;
  rulesComputedDelegates: A[];
  siteUrl: string;
}
